import { useEffect } from 'react'
import { ThemeProvider } from '../contexts/ThemeContext'
import { Provider } from 'react-redux'
import { store } from '../state/store'
import { useAppDispatch } from '../state/hooks'
import { setActiveCompany } from '../state/slices/companiesSlice'
import SettingsTab from '../components/tabs/SettingsTab'
import './SettingsPage.css'

/** Inner component that has access to Redux dispatch */
function SettingsPageInner() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Read company ID from URL params, default to company_1
    const params = new URLSearchParams(window.location.search)
    const companyId = params.get('company') || 'company_1'
    dispatch(setActiveCompany(companyId))
  }, [dispatch])

  return (
    <div className="settings-page">
      <div className="settings-page-header">
        <h1 className="settings-page-title">Settings</h1>
        <span className="settings-page-subtitle">Progressive Autonomy Platform Configuration</span>
      </div>
      <div className="settings-page-content">
        <SettingsTab />
      </div>
    </div>
  )
}

export default function SettingsPage() {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <SettingsPageInner />
      </ThemeProvider>
    </Provider>
  )
}
